const KlUBackgroundAlt = {
    beforeMount: (el: HTMLElement) => {
        const baseClass = 'kl-u-bg-alt';
        el.classList.add(baseClass);
    },
};

export default KlUBackgroundAlt;
